import { useEffect, useState } from 'react';
import { WebApp } from '../utils/webAppShim';
import { getAccessToken } from '../utils/accountStorage';

export default function LPAdminPanel({ user, apiUrl, onBack }) {
    const [members, setMembers] = useState([]);
    const [stations, setStations] = useState([]);
    const [inviteLink, setInviteLink] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const accountId = user?.accountId || user?.telegramId;

    useEffect(() => {
        if (!accountId) return;
        const headers = {
            'Content-Type': 'application/json',
            'X-Account-Id': String(accountId),
            'X-Telegram-Id': String(accountId),
        };
        const token = getAccessToken();
        if (!token) {
            setError('Требуется авторизация');
            setLoading(false);
            return;
        }
        headers.Authorization = `Bearer ${token}`;

        (async () => {
            try {
                const [membersRes, stationsRes, inviteRes] = await Promise.all([
                    fetch(`${apiUrl}/front/lp-admin/members`, { headers }),
                    fetch(`${apiUrl}/front/lp-admin/stations`, { headers }),
                    fetch(`${apiUrl}/front/lp-admin/invite-link`, { headers }),
                ]);

                const failed = [membersRes, stationsRes, inviteRes].find((r) => !r.ok);
                if (failed) {
                    const body = await failed.json().catch(() => ({}));
                    setError(body.error || `Ошибка загрузки (${failed.status})`);
                    return;
                }

                setMembers(await membersRes.json());
                setStations(await stationsRes.json());
                const inviteData = await inviteRes.json();
                setInviteLink(inviteData.link);
            } catch (e) {
                setError(e.message || 'Ошибка загрузки данных');
            } finally {
                setLoading(false);
            }
        })();
    }, [apiUrl, accountId]);

    const copyInvite = () => {
        if (!inviteLink) return;
        if (navigator.clipboard) {
            navigator.clipboard.writeText(inviteLink).then(() => {
                WebApp.showAlert('Ссылка скопирована');
            });
        } else {
            WebApp.showAlert(inviteLink);
        }
    };

    if (loading) return <p className="text-gray-400">Загрузка...</p>;

    if (error) {
        return (
            <div className="p-4">
                <button type="button" onClick={onBack} className="mb-4 text-blue-400">← Назад</button>
                <p className="text-red-400">{error}</p>
            </div>
        );
    }

    return (
        <div className="p-4">
            <button type="button" onClick={onBack} className="mb-4 text-blue-400">← Назад</button>
            <h2 className="text-xl font-bold mb-4">Управление организацией</h2>

            <section className="mb-6">
                <h3 className="font-semibold mb-2">Приглашение сотрудников</h3>
                {inviteLink ? (
                    <>
                        <p className="text-sm text-gray-400 break-all mb-3">{inviteLink}</p>
                        <button type="button" onClick={copyInvite} className="bg-blue-600 px-4 py-2 rounded">
                            Копировать ссылку
                        </button>
                    </>
                ) : (
                    <p className="text-gray-500">Ссылка недоступна</p>
                )}
            </section>

            <section className="mb-6">
                <h3 className="font-semibold mb-2">Сотрудники ({members.length})</h3>
                <ul className="text-sm space-y-1">
                    {members.map((m) => (
                        <li key={m._id || m.id}>{m.firstName} {m.lastName} — {m.accountId || m.telegramId}</li>
                    ))}
                </ul>
            </section>

            <section>
                <h3 className="font-semibold mb-2">Станции ({stations.length})</h3>
                <ul className="text-sm space-y-1">
                    {stations.map((s) => (
                        <li key={s._id || s.id}>{s.name || s.deviceId}</li>
                    ))}
                </ul>
            </section>
        </div>
    );
}
